const ApplicationName = 'Your products and services'

const Components = Object.freeze({
  dashboardComponentInt: 'YPS: Dashboard',
  dashboardYPAndServiceBreadcrumbComponentInt: {
    'data-centre-cloud': 'Data centre cloud Page Breadcrumb',
    'adaptive-networks': 'Adaptive networks Page Breadcrumb',
    'all-services': 'All services Page Bredcrumb',
  },
  serviceDetailsPageIntBreadcrumbComponentInt: {
    'data-centre-cloud': 'Data centre cloud Page Breadcrumb',
    'adaptive-networks': 'Adaptive networks Page Breadcrumb',
    'all-services': 'All services Page Bredcrumb',
  },
  allServicesPageInt: {
    'all-services': 'All services page',
  },
  adaptiveNetworksPageInt: {
    'data-centre-cloud': 'Data centre cloud Page',
    'adaptive-networks': 'Adaptive Networks Page',
    'Network and performance reports': 'SSOFeature:YP&S_AN:NetworkReports:International',
    'Cisco SD-WAN': 'SSOFeature:YP&S_AN:Cisco SD-WAN:International',
    'Meraki SD-WAN': 'SSOFeature:YP&S_AN:Meraki SD-WAN:International',
    'SD-WAN': 'SSOFeature:YP&S_AN:SD-WAN:International',
    'VMWare SD-WAN': 'SSOFeature:YP&S_AN:SD-WAN:International',
    'Route management': 'SSOFeature:YP&S_AN:Route management:International',
    'DNS management': 'SSOFeature:YP&S_AN:DNS management:International',
    'Starlink usage': 'Starlink usage',
    'Starlink telemetry': 'Starlink telemetry',
    'Update GID bandwidth': 'Update GID bandwidth',
    'Manage network services': 'Manage network services'

  },
  adaptiveNetworkSsoModalCancelButton: {
    'Network and performance reports': 'SSOFeature:YP&S_AN:NetworkReports:International:Cancel',
    'Cisco SD-WAN': 'SSOFeature:YP&S_AN:Cisco SD-WAN:International:Cancel',
    'Meraki SD-WAN': 'SSOFeature:YP&S_AN:Meraki SD-WAN:International:Cancel',
    'SD-WAN': 'SSOFeature:YP&S_AN:SD-WAN:International:Cancel',
    'VMWare SD-WAN': 'SSOFeature:YP&S_AN:SD-WAN:International:Cancel',
    'Starlink usage': 'Starlink usage:Cancel',
    'Starlink telemetry': 'Starlink telemetry:Cancel',
    'Update GID bandwidth': 'Update GID bandwidth:Cancel',
    'Manage network services': 'Manage network services:Cancel'
  },
  adaptiveNetworkSsoModalContinueButton: {
    'Network and performance reports': 'SSOFeature:YP&S_AN:NetworkReports:International:Continue',
    'Cisco SD-WAN': 'SSOFeature:YP&S_AN:Cisco SD-WAN:International:Continue',
    'Meraki SD-WAN': 'SSOFeature:YP&S_AN:Meraki SD-WAN:International:Continue',
    'SD-WAN': 'SSOFeature:YP&S_AN:SD-WAN:International:Continue',
    'VMWare SD-WAN': 'SSOFeature:YP&S_AN:SD-WAN:International:Continue',
    'Starlink usage': 'Starlink usage:Continue',
    'Starlink telemetry': 'Starlink telemetry:Continue',
    'Update GID bandwidth': 'Update GID bandwidth:Continue',
    'Manage network services': 'Manage network services:Continue'

  },
  fromPages: {
    'data-centre-cloud': 'Data centre cloud',
    'adaptive-networks': 'Adaptive networks',
    'all-services': 'All services',
    'service-details': 'Service details',
  },
  yourProductsServicesHomePage: 'Your Products and Services Home Page',
})

export { ApplicationName, Components }
